// General
import "./joining-call-overlay.scss";
// Redux
import { useSelector } from "react-redux";
// i18next
import { useTranslation } from "react-i18next";

const JoiningCallOverlay = () => {
  // Redux variables
  const showVideoCallJoiningOverlay = useSelector(
    (state) => state.privateCall.showVideoCallJoiningOverlay
  );
  const callerUsername = useSelector(
    (state) => state.privateCall.callerUsername
  );

  // i18next variables
  const { t } = useTranslation();

  if (showVideoCallJoiningOverlay) {
    return (
      <div id="private-standby-joining-call-overlay-subcomponent">
        <div className="username">{callerUsername || ""}</div>
        <div className="subheader">{t("1on1.joining_call")}</div>
      </div>
    );
  }
};

export default JoiningCallOverlay;
